import { __decorate } from "tslib";
import { Component, Vue, Ref, Prop, Watch } from 'vue-property-decorator';
import { getTaskList, deleteTargetsDetail, disableTask, enableTask } from '@blade-sxp/monitor/api/monitor-management/task';
import AuthItem from '@blade/common/components/auth/auth-item.vue';
let default_1 = class default_1 extends Vue {
    multipleTable;
    keyword;
    multipleSelection = [];
    multipleLength = 0;
    currentPage4 = 4;
    imgUrl = require('@blade/common/assets/images/user.png');
    taskList = [];
    order = 'descending';
    loading = false;
    pagination = {
        page: 1,
        size: 100,
        total: 0,
    };
    filterStatus = [];
    filterTaskStatus = [];
    filterStrategy = [];
    initI18n() {
        this.filterStatus = [
            { text: this.$t('common.enable'), value: 1 },
            { text: this.$t('common.disable'), value: -1 },
        ];
        this.filterTaskStatus = [
            { text: this.$t('status.abnormal'), value: 3 },
            { text: this.$t('status.effect'), value: 1 },
            // { text: this.$t('status.noEffective'), value: 2 },
        ];
        this.filterStrategy = [
            { text: this.$t('task.theNumberOfStatistics'), value: 2 },
            { text: this.$t('task.regionStatistic'), value: 10 },
        ];
    }
    formatStrategy(row, column, cellValue, index) {
        const allStrategy = {
            '2': this.$t('task.theNumberOfStatistics'),
            '10': this.$t('task.regionStatistic'),
        };
        const strategy = row.taskType;
        return (strategy && allStrategy[strategy]) || '';
    }
    filterStatusTag(value, row) {
        return row.taskStatus === value;
    }
    filterTaskStatusTag(value, row) {
        return row.taskRunStatus === value;
    }
    filterStrategyTag(value, row) {
        return row.taskType === value;
    }
    handleSelectionChange(val) {
        this.multipleSelection = val;
        this.multipleLength = this.multipleSelection.length;
    }
    toggleSelection() {
        this.multipleTable.clearSelection();
    }
    /**
     *@Description: 清空
     *@Date: 2020-09-10 18:19:59
     */
    handleClear(rows) {
        this.$refs.multipleTable.clearSelection();
    }
    handleSizeChange(val) {
        this.pagination.size = val;
        this.getTaskList();
    }
    handleCurrentChange(val) {
        this.pagination.page = val;
        this.getTaskList();
    }
    handleSort(cloumn, prop, order) {
        this.order = order;
        this.getTaskList();
    }
    getTaskList() {
        this.loading = true;
        const reqParam = {
            taskTypes: [2, 10],
            taskCategory: 'CROWD',
            page: this.pagination.page,
            size: this.pagination.size,
            keyword: this.keyword,
            // order:this.order==='ascending'?1:-1,
        };
        getTaskList({ ...reqParam })
            .then((re) => {
            this.loading = false;
            this.taskList = re.data.data.baseTaskVOList;
            const total = re.data.data.totalSize;
        })
            .catch((error) => {
            this.loading = false;
            this.$message.error(error.message);
        });
    }
    /**
     *@Description: 停用/启用
     *@Date: 2020-09-17 15:33:53
     */
    activeDevice(sid, status) {
        const respFunc = status === 1 ? disableTask : enableTask;
        // if(status===1){ // 停用设备
        let confirm = `${this.$t('common.confirm')}`;
        let deviceConfirmActive = status === 1 ? `${this.$t('device.confirmDisable')}` : `${this.$t('device.confirmActive')}`;
        this.$alert(deviceConfirmActive, {
            confirmButtonText: confirm,
            callback: (action) => {
                if (action === 'confirm') {
                    respFunc(sid)
                        .then((res) => {
                        this.$message({ message: res.data.message, type: 'success' });
                        this.getTaskList();
                    })
                        .catch((err) => {
                        this.$message({ message: err, type: 'error' });
                    });
                }
            },
        });
    }
    /**
     *@Description: 删除任务
     *@Date: 2020-09-17 10:08:01
     */
    handleDelete(sid) {
        let confirm = `${this.$t('common.confirm')}`;
        let deviceConfirmDelete = `${this.$t('device.confirmDelete')}`;
        this.$alert(deviceConfirmDelete, {
            confirmButtonText: confirm,
            callback: (action) => {
                if (action === 'confirm') {
                    deleteTargetsDetail(sid).then((res) => {
                        this.$message({
                            message: res.data.message,
                            type: 'success',
                        });
                        this.getTaskList();
                    }).catch((err) => {
                        this.$message.error(err.message);
                    });
                }
            },
        });
    }
    /**
     *@Description: 编辑任务
     *@Date: 2020-09-17 10:24:22
     */
    handleEdit(id) {
        this.$router.push(`/monitor/task/editcrowdStatistics/${id}`);
    }
    mounted() {
        this.getTaskList();
        this.initI18n();
    }
};
__decorate([
    Ref()
], default_1.prototype, "multipleTable", void 0);
__decorate([
    Prop()
], default_1.prototype, "keyword", void 0);
__decorate([
    Watch('$i18n.locale')
], default_1.prototype, "initI18n", null);
default_1 = __decorate([
    Component({
        name: 'TaskFaceControl',
        components: { AuthItem },
    })
], default_1);
export default default_1;
